export type ReviewSource = 'whatsapp' | 'facebook' | 'linkedin' | 'instagram' | 'reddit' | 'klix'

export interface Review {
  path: string
  /** Short line from the review itself, shown under the screenshot. */
  quote: string
  alt: string
  type: ReviewSource
  url?: string
}

export const REVIEWS: Review[] = [
  { path: '/landing/review-1.png', quote: 'eSIMFly najbolja, provjereno', alt: 'Facebook komentari u grupi Putovanje u Istanbul koji preporučuju eSIMFly.', type: 'facebook' },
  { path: '/landing/review-2.png', quote: 'Definitivno najbolji!', alt: 'Facebook komentar koji eSIMFly naziva najboljim izborom za Tursku, uz online podršku.', type: 'facebook' },
  {
    path: '/landing/review-8.png',
    quote: 'Domaći i provjereni, a najpovoljniji',
    alt: 'Facebook komentar o eSIMFly-u: domaći i provjereni već nekoliko puta, najpovoljniji, a podrška vrhunska.',
    type: 'facebook',
  },
  { path: '/landing/review-4.png', quote: 'Baš smo prezadovoljni', alt: 'WhatsApp poruka putnice koja je eSIMFly eSIM koristila u mnogo različitih zemalja i sve je radilo.', type: 'whatsapp' },
  { path: '/landing/review-5.png', quote: 'Ispalo je da su stvarno top', alt: 'Objava na Klix forumu o eSIMFly paketima korištenim po Evropi i Turskoj.', type: 'klix' },
  { path: '/landing/review-6.png', quote: 'Stvar je radila izvanredno', alt: 'LinkedIn objava o eSIMFly eSIM-u od 3 KM za 1 GB koji je radio izvanredno u inostranstvu.', type: 'linkedin' },
  { path: '/landing/review-7.png', quote: 'Highly recommend eSIMFly', alt: 'Reddit komentar koji preporučuje eSIMFly kao domaći brend za Bosnu i Hercegovinu.', type: 'reddit' },
  { path: '/landing/review-9.png', quote: 'Profesionalan customer support', alt: 'LinkedIn objava koja ističe pristupačne cijene, dobru ponudu i profesionalnu podršku eSIMFly-a.', type: 'linkedin' },
  {
    path: '/landing/review-10.png',
    quote: 'Provjereno, odlično funkcioniše',
    alt: 'Komentari na eSIMFly Facebook stranici: provjereno, odlično funkcioniše, koristim ga u Turskoj.',
    type: 'facebook',
  },
  { path: '/landing/review-11.png', quote: 'Ekstra ste brzi sa odgovorima', alt: 'WhatsApp poruka putnice oduševljene eSIMFly ponudom, brzinom odgovora i podrškom.', type: 'whatsapp' },
  { path: '/landing/review-12.png', quote: 'Internet vrhunski', alt: 'WhatsApp poruka putnika nakon slijetanja: eSIMFly internet vrhunski.', type: 'whatsapp' },
  { path: '/landing/review-13.png', quote: 'Koristila i super je', alt: 'Facebook komentari u grupi Putovanje u Istanbul: eSIMFly koristila i super je.', type: 'facebook' },
  { path: '/landing/review-14.png', quote: 'Stvarno sam oduševljen kako radi', alt: 'WhatsApp poruka putnika oduševljenog kako eSIMFly eSIM radi u Španiji, Njemačkoj i Hrvatskoj.', type: 'whatsapp' },
  { path: '/landing/review-15.png', quote: '5G, odlično funkcioniše', alt: 'Facebook komentar o eSIMFly eSIM-u za Tursku: 5G, odlično funkcioniše, bez ikakvih problema.', type: 'facebook' },
  { path: '/landing/review-16.png', quote: 'Testiran i veoma povoljan', alt: 'Facebook komentar o eSIMFly-u: testiran prije par dana i veoma povoljan, 5 GB za 8,70 KM.', type: 'facebook' },
  { path: '/landing/review-17.png', quote: 'Brz, stabilan i bez ikakvih problema', alt: 'Facebook komentar putnice kojoj je eSIMFly internet u Istanbulu radio brzo i stabilno.', type: 'facebook' },
  { path: '/landing/review-18.png', quote: 'Podrška za 10!', alt: 'Komentari na eSIMFly Facebook stranici: uvijek koristim i sve je bez greške, podrška za 10.', type: 'facebook' },
  { path: '/landing/review-3.png', quote: 'eSIMFly radi besprijekorno', alt: 'Facebook komentar u grupi Putovanje u Istanbul: eSIMFly radi besprijekorno.', type: 'facebook' },
  {
    path: '/landing/review-19.png',
    quote: 'Radi fenomenalno, a iz naše Bosne',
    alt: 'WhatsApp poruka hadžije kojem je eSIMFly internet u Saudijskoj Arabiji radio fenomenalno tokom hadža.',
    type: 'whatsapp',
  },
]

export const LANDING_REVIEWS_COUNT = 8

/** Fisher-Yates shuffle into a new array; called per request so every visit shows a different order. */
export function shuffleReviews(reviews: Review[] = REVIEWS) {
  const result = [...reviews]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}
